export default "__VITE_ASSET__B00EuXmS__"